import React, { useEffect, useState } from "react";
import { Modal, Button, Typography, Space, Divider, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedRole } from "../store/auth";
import { UserSwitchOutlined, RightOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const RoleSelectionModal = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    if (!user || !user.idToken) {
      setOpen(false);
      return;
    }

    // Identify all true roles for the user
    const roles = [];
    if (user.is_supervisor) roles.push({ key: "supervisor", label: "Supervisor" });
    if (user.is_tl) roles.push({ key: "team_lead", label: "Team Lead" });
    if (user.is_tc) roles.push({ key: "telecaller", label: "Telecaller" });
    if (user.is_fa) roles.push({ key: "field_agent", label: "Field Agent" });
    if (user.is_agency) roles.push({ key: "agency", label: "Agency" });

    // If user has no selected role yet...
    if (!user.selectedRole) {
      if (roles.length > 1) {
        // Multiple roles available -> Force selection
        setAvailableRoles(roles);
        setOpen(true);
      } else if (roles.length === 1) {
        // Only one role available -> Auto select
        dispatch(setSelectedRole(roles[0].key));
      }
    } else {
      // Role already selected
      setOpen(false);
    }
  }, [user, dispatch]);

  const handleRoleSelect = (roleKey) => {
    dispatch(setSelectedRole(roleKey));
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      centered
      width={450}
      bodyStyle={{ padding: "24px 32px" }}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <UserSwitchOutlined style={{ fontSize: "48px", color: "#1890ff", marginBottom: "12px" }} />
        <Title level={3} style={{ marginTop: 0, marginBottom: "8px" }}>Select Workspace</Title>
        <Text type="secondary" style={{ fontSize: "15px" }}>
          Your account has multiple roles. Please select the role you want to access for this session.
        </Text>
      </div>
      
      <Divider style={{ margin: "16px 0" }} />

      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {availableRoles.map((role) => (
          <Button
            key={role.key}
            block
            size="large"
            style={{
              height: "auto",
              padding: "16px",
              textAlign: "left",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #d9d9d9",
              boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
              fontWeight: 500,
              fontSize: "16px"
            }}
            onClick={() => handleRoleSelect(role.key)}
            className="role-selection-btn"
          >
            <span>{role.label}</span>
            <RightOutlined style={{ color: "#bfbfbf", fontSize: "14px" }} />
          </Button>
        ))}
      </Space>
    </Modal>
  );
};

export default RoleSelectionModal;
